import { combineReducers } from "@reduxjs/toolkit";
import ContactUsServiceStore from "@/cms/reducers/services/ContactUsServiceStore";

const Store = ( screenCode:string ) => {
    return combineReducers({
        ContactUsStore: ContactUsServiceStore({ screenCode })
    });
}

export default Store;
